import { TrashSVG } from '@Component/Modals/DeleteModal/TrashSVG';
import { FormattedMessage } from 'react-intl';
import { DeleteStatus } from '@Page/Overview/actions/useDeleteVoucher.ts';
import {
    Alert,
    AlertContent,
    Button,
    Modal,
    ModalContent,
    ModalFooter,
    ModalIllustration,
    ModalLayout,
    ModalTitle,
} from '@tlx/atlas';
import { SpinnerButton } from '@tlx/tsk-shared';

export function DeleteModal({
    open,
    onClose,
    onConfirm,
    deleteStatus,
}: {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    deleteStatus: DeleteStatus;
}) {
    return (
        <Modal open={open} onClose={onClose} className="tsk-delete-modal">
            <ModalLayout>
                {/* {deleteStatus !== DeleteStatus.LOADING && <ModalCloseButton />} */}
                {/**
                 * see https://tripletex.slack.com/archives/C05C9CA6FE2/p1719835709075169
                 * commented out the <ModalCloseButton/> so that the Primary button got focus, allowing you to press enter to delete
                 * tried to use a ref and give it focus that way, but didnt want to spend forever on it
                 */}
                <ModalIllustration>
                    <TrashSVG />
                </ModalIllustration>

                <ModalTitle>
                    <FormattedMessage id="text_are_you_sure" />
                </ModalTitle>
                <ModalContent className="tsk-delete-modal-content atl-flex atl-flex-col atl-gap-16">
                    {deleteStatus === DeleteStatus.ERROR && (
                        <Alert variant="error">
                            <AlertContent>
                                <FormattedMessage id="heading_unexpected_error" />
                            </AlertContent>
                        </Alert>
                    )}
                    <FormattedMessage id="tsk_modal_delete_description" />
                </ModalContent>
                <ModalFooter>
                    <div className="atl-flex atl-gap-8">
                        <SpinnerButton
                            variant="primary"
                            data-testid="modal-delete-confirm"
                            onClick={onConfirm}
                            isLoading={deleteStatus === DeleteStatus.LOADING}
                        >
                            <FormattedMessage id="text_delete_voucher" />
                        </SpinnerButton>
                        <Button
                            data-testid="modal-delete-cancel"
                            variant="secondary"
                            onClick={onClose}
                            disabled={deleteStatus === DeleteStatus.LOADING}
                        >
                            <FormattedMessage id="text_cancel" />
                        </Button>
                    </div>
                </ModalFooter>
            </ModalLayout>
        </Modal>
    );
}
